import { defineNuxtPlugin, useRuntimeConfig } from '#app'
import * as Sentry from '@sentry/vue'

export default defineNuxtPlugin(async ({ vueApp }) => {
  const { public: { SENTRY_DSN, SENTRY_ENV, SENTRY_RELEASE } } = useRuntimeConfig()

  Sentry.init({
    dsn: SENTRY_DSN,
    app: [vueApp],
    release: SENTRY_RELEASE,
    environment: SENTRY_ENV,
    enabled: SENTRY_ENV == 'staging' || SENTRY_ENV === 'production',
    debug: SENTRY_ENV === 'development',
    ignoreErrors: [],
    tracesSampleRate: 0,
    profilesSampleRate: 0,
    integrations: [
      Sentry.browserTracingIntegration()
    ],
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
  })
})
